import React from 'react';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import './assets/scss/style.scss';
import 'swiper/css';
import AppRouter from './AppRouter';
import Footer from './components/Footer';
import { PreferencesProvider } from './context/PreferencesContext';
import VariantDebug from './utils/VariantDebug';

function App() {
  return (
    <>
      <PreferencesProvider>
        <AppRouter />
        <Footer />
        {import.meta.env.MODE === 'development' && <VariantDebug />}
      </PreferencesProvider>
    </>
  );
}

export default App;
